import React from 'react';
import { Container, Body5 } from '@ui';

import { TransparentFlatButton } from '@ui/buttons';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper, AgentFlowSVGIconButton } from '@flow/styles';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';

const QueryListItem = ({ value, handleChange }) => {
  const [useDropdown, setUseDropdown] = React.useState(false);
  const [values] = React.useState([
    '{{DOC_SET_ANALYSIS_QUESTIONS_FOR_ORIGINAL_QUERY}}',
    '{{COMPANY_TICKER_LIST_DOC_ID}}',
    '{{DOC_SET_ANALYSIS_QUESTIONS_FOR_INPUT}}',
  ]);

  React.useEffect(() => {
    if (values.includes(value)) {
      setUseDropdown(true);
    }
  }, []);

  const handleToggleDropdown = () => {
    setUseDropdown(!useDropdown);
  };

  if (useDropdown) {
    return (
      <Container fullWidth row verticallyCenter>
        <select value={value} onChange={(e) => handleChange(e, 0)}>
          <option value={null}>Select One...</option>
          {values.map((v) => (
            <option key={v} value={v}>
              {v.replace('{{', '').replace('}}', '')}
            </option>
          ))}
        </select>
        <AgentFlowSVGIconButton onClick={handleToggleDropdown}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z" />
          </svg>
        </AgentFlowSVGIconButton>
      </Container>
    );
  }
  return (
    <Container fullWidth row verticallyCenter>
      <textarea value={value} onChange={(e) => handleChange(e, 0)} />
      <AgentFlowSVGIconButton onClick={handleToggleDropdown}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M15 5H18L16.5 7L15 5M5 2H19C20.11 2 21 2.9 21 4V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V4C3 2.9 3.9 2 5 2M5 4V8H19V4H5M5 20H19V10H5V20M7 12H17V14H7V12M7 16H17V18H7V16Z" />
        </svg>
      </AgentFlowSVGIconButton>
    </Container>
  );
};

export const StringListOrValueParameter = ({ data, value, onRemove, onChange }) => {
  const [isList, setIsList] = React.useState(false);

  const { keyName, label } = data;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const syncItems = () => {
      if (Array.isArray(value)) {
        setIsList(true);
        setItems(value);
      }
    };
    syncItems();
  }, []);

  const handleAddItem = () => {
    setItems((prevItems) => [...prevItems, '']);
  };

  const handleChange = (e, i) => {
    const value = e.target.value;
    if (isList) {
      setItems((prevItems) => {
        const copy = [...prevItems];
        copy[i] = value;
        onChange(keyName, copy);
        return copy;
      });
    } else {
      onChange(keyName, value);
    }
  };

  const handleRemoveClick = () => {
    onRemove(keyName);
  };

  const handleRemoveItemClick = (i) => {
    setItems((prevItems) => {
      const copy = [...prevItems];
      const newItems = copy.filter((el, elIndex) => elIndex !== i);
      onChange(keyName, newItems);
      return newItems;
    });
  };

  const onToggleListOrValue = () => {
    if (isList) {
      setItems([]);
      onChange(keyName, '');
      setIsList(false);
    } else {
      setItems([]);
      setIsList(true);
    }
  };

  return (
    <AgentFlowParameterWrapper>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <Container row verticallyCenter>
            <AgentFlowParameterLabelWrapper>
              <Body5>{label}:</Body5>
            </AgentFlowParameterLabelWrapper>
            <div className="read-only-hide" style={{ display: 'flex', gap: 8 }}>
              {isList ? (
                <TransparentFlatButton onClick={onToggleListOrValue}>Toggle to Value</TransparentFlatButton>
              ) : (
                <TransparentFlatButton onClick={onToggleListOrValue}>Toggle to List</TransparentFlatButton>
              )}
              {isList && <TransparentFlatButton onClick={handleAddItem}>Add List Item</TransparentFlatButton>}
            </div>
          </Container>

          <NodeParameterRemoveButton onClick={handleRemoveClick} />
        </Container>
        {isList ? (
          <ul>
            {items.map((item, index) => (
              <li key={index}>
                <Container fullWidth row verticallyCenter>
                  <textarea value={item} onChange={(e) => handleChange(e, index)} />
                  <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
                </Container>
              </li>
            ))}
          </ul>
        ) : keyName === 'query_list' ? (
          <QueryListItem value={value} handleChange={handleChange} />
        ) : (
          <textarea value={value} onChange={(e) => handleChange(e, 0)} />
        )}
      </Container>
    </AgentFlowParameterWrapper>
  );
};
